import { render, staticRenderFns } from "./AddBlockContent.vue?vue&type=template&id=95f9499c&"
import script from "./AddBlockContent.vue?vue&type=script&lang=js&"
export * from "./AddBlockContent.vue?vue&type=script&lang=js&"
import style0 from "./AddBlockContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports